module.exports = __webpack_public_path__ + "static/media/icon-profile.a5f703db.svg";